import React from "react";
import FavoriteDetailsContainer from "../../containers/ProfileContainer/FavoriteDetailsContainer";

const FavoriteDetailsPage = () => {
  return <FavoriteDetailsContainer />;
};
export default FavoriteDetailsPage;
